// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#rcorners {
  border-radius: 10px;
  font-size: 14px;
}

#rcorners-circle {
  border-radius: 100%;
  border-collapse: separate;
  display: inline-block;
  width: 120px;
  height: 120px;
  line-height: 120px;
}

#rcorners-wi-border {
  border-radius: 25%;
  font-size: 14px;
}

#rcorners-100 {
  border-radius: 100%;
  font-size: 14px;
}

.table-rounded {
  align-self: center;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-align: center;
  border-spacing: 0;
  border: solid #ccc 1px;
  border-radius: 10px;
  box-shadow: 0 2px 2px #ccc;
}

.table-rounded th:first-child {
  border-radius: 10px 0 0 0;
}

.table-rounded th:last-child {
  border-radius: 0 10px 0 0;
}

.table-rounded th:only-child {
  border-radius: 6px 10px 0 0;
}

.table-rounded tbody tr:last-child td:first-child {
  border-radius: 0 0 0 10px;
}

.table-rounded tbody tr:last-child td:last-child {
  border-radius: 0 0 10px 0;
}

div.vastyle {
  font-family: Lato, sans-serif;
}

tr.total {
  font-family: Lato, sans-serif;
  background: lightgrey;
  color: white;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-align: center;
}

h1 {
  font-family: Lato, sans-serif;
}

h2 {
  font-family: Lato, sans-serif;
}

h3 {
  font-family: Lato, sans-serif;
}

.va-table {
  align-self: center;
  font-family: Lato, sans-serif;
  font-size: 14px;
  text-align: center;
}

.va-table th {
  background: #275362;
  color: white;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-align: center;
}

.va-table-right-align-col td + td {
  text-align: right;
}

.va-table-striped-col td:nth-child(2n) {
  background: lightgrey;
}

.va-table-striped-row tr:nth-child(2n) {
  background: lightgrey;
}

.oxs-table {
  align-self: center;
  font-family: Lato, sans-serif;
  font-size: 14px;
  text-align: center;
}

.oxs-table th {
  background: #275362;
  color: white;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-align: center;
}

.oxs-table-striped-col td:nth-child(2n) {
  background: lightgrey;
}

.oxs-table-striped-row tr:nth-child(2n) {
  background: lightgrey;
}

.ox-table {
  align-self: center;
  font-family: Lato, sans-serif;
  font-size: 14px;
  text-align: center;
}

.ox-table th {
  background: #275362;
  color: white;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-align: center;
}

.ox-table-right-align-col td + td {
  text-align: right;
}

.ox-table-striped-col td:nth-child(2n) {
  background: lightgrey;
}

.ox-table-striped-row tr:nth-child(2n) {
  background: lightgrey;
}

.mlet-hide-header th {
  display: none;
}

/* VA Marketing Team table */
.vam-table {
  align-self: center;
  font-family: Lato, sans-serif;
  font-size: 14px;
  text-align: center;
}

.vam-table th {
  background: #275362;
  color: white;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-align: center;
}

.vam-table-striped-col td:nth-child(2n) {
  background: lightgrey;
}

.vam-table-striped-row tr:nth-child(2n) {
  background: lightgrey;
}

/* VA Marketing Team table 2*/
.vam2-table {
  font-family: Lato, sans-serif;
  font-size: 15px;
  text-align: left;
  font-weight: bold;
}

.vam2-table th {
  background-color: #275362;
  color: white;
  padding: 5px;
}

.vam2-table td {
  padding: 5px;
}

.vam2-table td:nth-child(odd) {
  background-color: #018181;
  color: white;
}

.vam2-table tr:last-child td:first-child, .vam2-table tr:last-child td:last-child {
  color: white;
  background-color: #92D050;
}

/* VA Marketing Team table 2 END*/
@keyframes blinker {
  0% {
    visibility: visible;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}
.va-cursor {
  animation: blinker steps(1) 500ms infinite alternate;
}

.table-mlet td + td {
  text-align: right;
}

.table-mlet {
  align-self: center;
}

.va-mlet td:nth-child(2n) {
  background: lightgrey;
}

.table-mlet th {
  visible: hidden;
  text-align: center;
  background: #275362;
  font-size: 16px;
  color: white;
}

.table-local td {
  vertical-align: top;
}

.table-local th {
  text-align: center;
  background: #275362;
  font-size: 16px;
  color: white;
}

.table-no-border {
  border: 0px;
  border-color: white;
}

.table-no-header th {
  display: none;
}

/* Used in Products Goals */
.projectsummarytable {
  background: #eee;
  border: 5px solid white;
}

.projectsummarytable td {
  border: 5px solid white;
  padding: 2px;
}

#rends {
  border-radius: 0 16px 16px 0;
}

#rstarts {
  border-radius: 16px 0 0 16px;
}

#logo {
  display: inline-block;
  position: relative;
}

#logo .speedometer {
  width: 120px;
  height: 120px;
  border-radius: 100%;
  border: 20px solid #000;
  border-color: #5e535e;
  border-right: 20px solid #666666;
  border-bottom: 20px solid #666666;
  -webkit-transform: rotate(45deg);
  display: inline-block;
}

#logo .needle {
  width: 5px;
  height: 50px;
  background: blue;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
  display: inline-block;
  left: 56px;
  position: absolute;
  top: 10px;
  font-size: x-large;
  color: white;
}

#logo .reading_insurance_service {
  -webkit-animation: move_insurance_service 5s forwards;
  transform: rotate(0deg);
  transform-origin: bottom;
  animation-fill-mode: forwards;
}

@-webkit-keyframes move_insurance_service {
  0% {
    transform: rotate(-90deg);
    background: blue;
  }
  50% {
    transform: rotate(90deg);
    background: blue;
  }
  100% {
    transform: rotate(-49deg);
    transform: rotate(18deg);
    background: gold;
  }
}
#logo .reading_logistics_service {
  -webkit-animation: move_logistics_service 5s forwards;
  transform: rotate(0deg);
  transform-origin: bottom;
  animation-fill-mode: forwards;
}

@-webkit-keyframes move_logistics_service {
  0% {
    transform: rotate(-90deg);
    background: blue;
  }
  50% {
    transform: rotate(90deg);
    background: blue;
  }
  100% {
    transform: rotate(-90deg);
    transform: rotate(-90deg);
    background: red;
  }
}
#logo .reading_products {
  -webkit-animation: move_products 5s forwards;
  transform: rotate(0deg);
  transform-origin: bottom;
  animation-fill-mode: forwards;
}

@-webkit-keyframes move_products {
  0% {
    transform: rotate(-90deg);
    background: blue;
  }
  50% {
    transform: rotate(90deg);
    background: blue;
  }
  100% {
    transform: rotate(-45deg);
    transform: rotate(-74.5714285714deg);
    background: gold;
  }
}
.debuglinks {
  color: white;
}

.debuglinks:hover {
  background-color: lighblue;
}

.ox-links a {
  display: block;
  position: relative;
}

.ox-links a:hover {
  color: lighblue;
  text-decoration: none;
  font-weight: bold;
}

.ox-links a::after {
  transition: transform 400ms ease-in;
  content: "";
  width: 100%;
  bottom: 0;
  left: 0;
  position: absolute;
  height: 2px;
  background-color: #10c55f;
  transform: scale(0);
}

.ox-links a:hover::after {
  transform: scale(0.5);
  transform-origin: center;
}

:root {
  --status-color: Assigned;
}

.bg_funnel {
  background-image: url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/191_image.png);
  background-position-x: center;
  background-position-y: center;
  background-size: 100%;
}

.bg_funnel_1 {
  background-image: url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/193_image.png);
  background-position-x: center;
  background-position-y: center;
  background-size: 50%;
}

.bg_funnel_2 {
  background-image: url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/194_image.png);
  background-position-x: center;
  background-position-y: center;
  background-size: 50%;
}

.bg_funnel_3 {
  background-image: url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/195_image.png);
  background-position-x: center;
  background-position-y: center;
  background-size: 50%;
}

.bg_funnel_4 {
  background-image: url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/196_image.png);
  background-position-x: center;
  background-position-y: center;
  background-size: 50%;
}

#box-contain1 {
  padding: 30px;
  border: 2px dashed teal;
  margin-bottom: 5px;
}

#box-contain2 {
  padding: 30px;
  border: 5px double teal;
}

figure.oxzion-widget,
div.oxzion-widget {
  text-align: center;
  outline: solid 1px #ccc;
  background: rgba(0, 0, 0, 0.05);
  padding: 10px;
  margin: 10px 20px;
  display: inline-block;
}

/* figure > figcaption, */
figure.oxzion-widget > figcaption {
  text-align: center;
  display: block; /* For IE8 */
}

.ck-content .image {
  display: table;
  clear: both;
  text-align: center;
  margin: 1em auto;
}

.ck-content .image > img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  min-width: 50px;
}

.ck-content .image > figcaption {
  display: table-caption;
  caption-side: bottom;
  word-break: break-word;
  color: #333;
  background-color: #f7f7f7;
  padding: 0.6em;
  font-size: 0.75em;
  outline-offset: -1px;
}

.ck-content .image-style-align-center,
.ck-content .image-style-align-left,
.ck-content .image-style-align-right,
.ck-content .image-style-side {
  max-width: 50%;
}

.ck-content .image-style-side {
  float: right;
  margin-left: var(--ck-image-style-spacing);
}

.ck-content .image-style-align-left {
  float: left;
  margin-right: var(--ck-image-style-spacing);
}

.ck-content .image-style-align-center {
  margin-left: auto;
  margin-right: auto;
}

.ck-content .image-style-align-right {
  float: right;
  margin-left: var(--ck-image-style-spacing);
}

.ck-content .image.image_resized {
  max-width: 100%;
  display: block;
  box-sizing: border-box;
}

.ck-content .image.image_resized img {
  width: 100%;
}

.ck-content .image.image_resized > figcaption {
  display: block;
}

.ck-content .media {
  clear: both;
  margin: 1em 0;
  display: block;
  min-width: 15em;
}

.ck-content .table {
  margin: 1em auto;
  display: table;
}

.ck-content .table table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  height: 100%;
  border: 1px double #b3b3b3;
}

.ck-content .table table td,
.ck-content .table table th {
  min-width: 2em;
  padding: 0.4em;
  border: 1px solid #bfbfbf;
}

.ck-content .table table th {
  font-weight: 700;
  background: hsla(0, 0%, 0%, 5%);
}

.ck-content[dir=rtl] .table th {
  text-align: right;
}

.ck-content[dir=ltr] .table th {
  text-align: left;
}

.ck-content .text-tiny {
  font-size: 0.7em;
}

.ck-content .text-small {
  font-size: 0.85em;
}

.ck-content .text-big {
  font-size: 1.4em;
}

.ck-content .text-huge {
  font-size: 1.8em;
}

.ck-content blockquote {
  overflow: hidden;
  padding-right: 1.5em;
  padding-left: 1.5em;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  border-left: 5px solid #ccc;
}

.ck-content[dir=rtl] blockquote {
  border-left: 0;
  border-right: 5px solid #ccc;
}

.activityLogWindow .logResults .gridActions .ck-content {
  width: 100%;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/ckeditorStyle.css"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,eAAA;AACJ;;AACC;EACI,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAEL;;AAAC;EACI,kBAAA;EACD,eAAA;AAGJ;;AADC;EACI,mBAAA;EACD,eAAA;AAIJ;;AAFC;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAKL;;AAFC;EACI,yBAAA;AAKL;;AAFC;EACI,yBAAA;AAKL;;AAFC;EACI,2BAAA;AAKL;;AAFC;EACI,yBAAA;AAKL;;AAHC;EACI,yBAAA;AAML;;AAJC;EACI,6BAAA;AAOL;;AALC;EACI,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAQL;;AANC;EACI,6BAAA;AASL;;AANC;EACI,6BAAA;AASL;;AANC;EACI,6BAAA;AASL;;AALC;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAQL;;AALC;EACI,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAQL;;AANC;EACA,iBAAA;AASD;;AANC;EACI,qBAAA;AASL;;AAPC;EACI,qBAAA;AAUL;;AANC;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AASL;;AAPC;EACI,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAUL;;AARC;EACI,qBAAA;AAWL;;AATC;EACI,qBAAA;AAYL;;AATC;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAYL;;AAVC;EACI,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAaL;;AAXC;EACA,iBAAA;AAcD;;AAZC;EACI,qBAAA;AAeL;;AAbC;EACI,qBAAA;AAgBL;;AAbC;EACA,aAAA;AAgBD;;AAbC,4BAAA;AACA;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAgBL;;AAdC;EACI,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAiBL;;AAfC;EACI,qBAAA;AAkBL;;AAhBC;EACI,qBAAA;AAmBL;;AAhBC,6BAAA;AAEA;EACI,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAkBL;;AAfC;EACI,yBAAA;EACA,YAAA;EACA,YAAA;AAkBL;;AAhBC;EACI,YAAA;AAmBL;;AAjBC;EACI,yBAAA;EACA,YAAA;AAoBL;;AAjBC;EACI,YAAA;EACA,yBAAA;AAoBL;;AAjBC,iCAAA;AAGA;EACE;IAAK,mBAAA;EAmBN;EAlBC;IAAM,kBAAA;EAqBP;EApBC;IAAO,mBAAA;EAuBR;AACF;AArBC;EACE,oDAAA;AAuBH;;AAnBC;EACI,iBAAA;AAsBL;;AAnBC;EACK,kBAAA;AAsBN;;AApBC;EACI,qBAAA;AAuBL;;AArBC;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAwBL;;AAtBC;EACI,mBAAA;AAyBL;;AAvBC;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AA0BL;;AAxBC;EACE,WAAA;EACA,mBAAA;AA2BH;;AAzBC;EACA,aAAA;AA4BD;;AAxBC,2BAAA;AAEA;EACA,gBAAA;EACI,uBAAA;AA0BL;;AAxBC;EACA,uBAAA;EACI,YAAA;AA2BL;;AAxBC;EAAS,4BAAA;AA4BV;;AA3BC;EAAW,4BAAA;AA+BZ;;AA7BC;EAEQ,qBAAA;EACA,kBAAA;AA+BT;;AA5BK;EAEI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gCAAA;EACA,iCAAA;EACA,gCAAA;EACA,qBAAA;AA8BT;;AA3BK;EAEI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AA6BT;;AA1BK;EAEI,qDAAA;EACF,uBAAA;EACA,wBAAA;EACA,6BAAA;AA4BP;;AA1BK;EACE;IACE,yBAAA;IACA,gBAAA;EA6BP;EA3BK;IACE,wBAAA;IACA,gBAAA;EA6BP;EA3BK;IACE,yBAAA;IACA,wBAAA;IACA,gBAAA;EA6BP;AACF;AA1BK;EAEI,qDAAA;EACF,uBAAA;EACA,wBAAA;EACA,6BAAA;AA2BP;;AAzBK;EACE;IACE,yBAAA;IACA,gBAAA;EA4BP;EA1BK;IACE,wBAAA;IACA,gBAAA;EA4BP;EA1BK;IACE,yBAAA;IACA,yBAAA;IACA,eAAA;EA4BP;AACF;AAzBK;EAEI,4CAAA;EACF,uBAAA;EACA,wBAAA;EACA,6BAAA;AA0BP;;AAxBK;EACE;IACE,yBAAA;IACA,gBAAA;EA2BP;EAzBK;IACE,wBAAA;IACA,gBAAA;EA2BP;EAzBK;IACE,yBAAA;IACA,oCAAA;IACA,gBAAA;EA2BP;AACF;AAzBC;EACG,YAAA;AA2BJ;;AAzBC;EACG,0BAAA;AA4BJ;;AA1BC;EACI,cAAA;EACA,kBAAA;AA6BL;;AA3BC;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AA8BD;;AA5BC;EACI,mCAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AA+BL;;AA7BC;EACI,qBAAA;EACA,wBAAA;AAgCL;;AA5BC;EACA,wBAAA;AA+BD;;AA7BC;EACG,kGAAA;EACA,6BAAA;EAA8B,6BAAA;EAC9B,qBAAA;AAiCJ;;AA/BC;EACG,kGAAA;EACA,6BAAA;EACA,6BAAA;EAA8B,oBAAA;AAmClC;;AAjCC;EACG,kGAAA;EACA,6BAAA;EACA,6BAAA;EACA,oBAAA;AAoCJ;;AAlCC;EACG,kGAAA;EACA,6BAAA;EACA,6BAAA;EACA,oBAAA;AAqCJ;;AAnCC;EACG,kGAAA;EACA,6BAAA;EACA,6BAAA;EACA,oBAAA;AAsCJ;;AAnCC;EACA,aAAA;EAAc,uBAAA;EACd,kBAAA;AAuCD;;AArCC;EACA,aAAA;EACA,uBAAA;AAwCD;;AArCC;;EAGA,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;AAuCD;;AApCA,yBAAA;AACA;EAEC,kBAAA;EACA,cAAA,EAAA,YAAA;AAsCD;;AAnCA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAsCJ;;AApCE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAuCJ;;AApCE;EACE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AAuCJ;;AApCE;;;;EAIE,cAAA;AAuCJ;;AArCE;EACE,YAAA;EACA,0CAAA;AAwCJ;;AAtCE;EACE,WAAA;EACA,2CAAA;AAyCJ;;AAvCE;EACE,iBAAA;EACA,kBAAA;AA0CJ;;AAxCE;EACE,YAAA;EACA,0CAAA;AA2CJ;;AAzCE;EACE,eAAA;EACA,cAAA;EACA,sBAAA;AA4CJ;;AA1CE;EACE,WAAA;AA6CJ;;AA3CE;EACE,cAAA;AA8CJ;;AA5CE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA+CJ;;AA7CE;EACE,gBAAA;EACA,cAAA;AAgDJ;;AA9CE;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AAiDJ;;AA/CE;;EAEE,cAAA;EACA,cAAA;EACA,yBAAA;AAkDJ;;AAhDE;EACE,gBAAA;EACA,+BAAA;AAmDJ;;AAjDE;EACE,iBAAA;AAoDJ;;AAlDE;EACE,gBAAA;AAqDJ;;AAnDE;EACE,gBAAA;AAsDJ;;AApDE;EACE,iBAAA;AAuDJ;;AArDE;EACE,gBAAA;AAwDJ;;AAtDE;EACE,gBAAA;AAyDJ;;AAvDE;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AA0DJ;;AAxDE;EACE,cAAA;EACA,4BAAA;AA2DJ;;AAxDE;EACE,WAAA;EACA,qBAAA;AA2DJ","sourcesContent":["#rcorners{ \n    border-radius: 10px; \n    font-size:14px; \n } \n #rcorners-circle {\n     border-radius: 100%;\n     border-collapse: separate; \n     display: inline-block;\n     width: 120px;\n     height: 120px;\n     line-height: 120px;\n } \n #rcorners-wi-border {\n     border-radius: 25%;\n    font-size: 14px; \n } \n #rcorners-100 {\n     border-radius: 100%;\n    font-size: 14px; \n }\n .table-rounded {\n     align-self: center;\n     font-family:Lato, sans-serif;\n     font-size: 16px;\n     text-align: center;\n     border-spacing: 0; \n     border: solid #ccc 1px;\n     border-radius: 10px;\n     box-shadow: 0 2px 2px #ccc;\n }\n \n .table-rounded th:first-child {\n     border-radius: 10px 0 0 0;\n }\n \n .table-rounded th:last-child {\n     border-radius: 0 10px 0 0;\n }\n \n .table-rounded th:only-child{\n     border-radius: 6px 10px 0 0;\n }\n \n .table-rounded tbody tr:last-child td:first-child {\n     border-radius: 0 0 0 10px;\n }\n .table-rounded tbody tr:last-child td:last-child {\n     border-radius: 0 0 10px 0;\n }\n div.vastyle {\n     font-family:Lato, sans-serif;\n }\n tr.total {\n     font-family:Lato, sans-serif;\n     background: lightgrey;\n     color: white;\n     font-family:Lato, sans-serif;\n     font-size: 16px;\n     text-align: center;\n }\n h1 {\n     font-family: Lato, sans-serif;\n     \n }\n h2 {\n     font-family: Lato, sans-serif;\n \n }\n h3 {\n     font-family: Lato, sans-serif;\n \n }\n \n .va-table {\n     align-self: center;\n     font-family:Lato, sans-serif;\n     font-size: 14px;\n     text-align: center;\n }\n \n .va-table th {\n     background: #275362;\n     color: white;\n     font-family:Lato, sans-serif;\n     font-size: 16px;\n     text-align: center;\n }\n .va-table-right-align-col td + td {\n text-align: right;\n }\n \n .va-table-striped-col td:nth-child(2n) {\n     background: lightgrey;\n } \n .va-table-striped-row tr:nth-child(2n) {\n     background: lightgrey;\n \n }\n \n .oxs-table {\n     align-self: center;\n     font-family:Lato, sans-serif;\n     font-size: 14px;\n     text-align: center;\n }\n .oxs-table th {\n     background: #275362;\n     color: white;\n     font-family:Lato, sans-serif;\n     font-size: 16px;\n     text-align: center;\n }\n .oxs-table-striped-col td:nth-child(2n) {\n     background: lightgrey;\n }\n .oxs-table-striped-row tr:nth-child(2n) {\n     background: lightgrey;\n \n }\n .ox-table {\n     align-self: center;\n     font-family:Lato, sans-serif;\n     font-size: 14px;\n     text-align: center;\n }\n .ox-table th {\n     background: #275362;\n     color: white;\n     font-family:Lato, sans-serif;\n     font-size: 16px;\n     text-align: center;\n }\n .ox-table-right-align-col td + td {\n text-align: right;\n }\n .ox-table-striped-col td:nth-child(2n) {\n     background: lightgrey;\n } \n .ox-table-striped-row tr:nth-child(2n) {\n     background: lightgrey;\n \n }\n .mlet-hide-header th {\n display: none;\n }\n \n /* VA Marketing Team table */\n .vam-table {\n     align-self: center;\n     font-family:Lato, sans-serif;\n     font-size: 14px;\n     text-align: center;\n }\n .vam-table th {\n     background: #275362;\n     color: white;\n     font-family:Lato, sans-serif;\n     font-size: 16px;\n     text-align: center;\n }\n .vam-table-striped-col td:nth-child(2n) {\n     background: lightgrey;\n } \n .vam-table-striped-row tr:nth-child(2n) {\n     background: lightgrey;\n \n }\n /* VA Marketing Team table 2*/\n \n .vam2-table {\n     font-family: Lato, sans-serif;\n     font-size: 15px;\n     text-align: left;\n     font-weight: bold;\n }\n \n .vam2-table th {\n     background-color: #275362;\n     color: white;\n     padding: 5px;\n }\n .vam2-table td {\n     padding: 5px;\n }\n .vam2-table td:nth-child(odd)  {\n     background-color: #018181;\n     color: white;\n }\n \n .vam2-table tr:last-child td:first-child,.vam2-table tr:last-child td:last-child {\n     color: white;\n     background-color: #92D050;\n }\n \n /* VA Marketing Team table 2 END*/\n \n \n @keyframes blinker {  \n   0% { visibility: visible; }\n   50% { visibility: hidden; }\n   100% { visibility: visible; }\n }\n \n .va-cursor {\n   animation: blinker steps(1) 500ms infinite alternate;\n }\n \n \n .table-mlet td + td {\n     text-align: right;\n }\n \n .table-mlet {\n      align-self: center; \n } \n .va-mlet td:nth-child(2n) {\n     background: lightgrey;\n } \n .table-mlet th {\n     visible: hidden;\n     text-align: center;\n     background: #275362;\n     font-size: 16px;\n     color: white;\n }\n .table-local td {\n     vertical-align: top;\n }\n .table-local th {\n     text-align: center;\n     background: #275362;\n     font-size: 16px;\n     color: white;\n }\n .table-no-border {\n   border:0px;\n   border-color: white;\n }\n .table-no-header th {\n display: none;\n }\n \n \n /* Used in Products Goals */\n \n .projectsummarytable {\n background: #eee;\n     border: 5px solid white;\n }\n .projectsummarytable td{\n border: 5px solid white;\n     padding: 2px;\n }\n \n #rends { border-radius: 0 16px 16px 0; } \n #rstarts { border-radius: 16px 0 0 16px; }\n \n #logo\n     {\n         display: inline-block;\n         position: relative;\n     }\n \n     #logo .speedometer\n     {\n         width: 120px;\n         height: 120px;\n         border-radius: 100%;\n         border: 20px solid #000;\n         border-color: #5e535e;\n         border-right: 20px solid #666666;\n         border-bottom: 20px solid #666666;\n         -webkit-transform: rotate(45deg);\n         display: inline-block;\n     }\n \n     #logo .needle\n     {\n         width: 5px;\n         height: 50px;\n         background: blue;\n         border-bottom-left-radius: 5px;\n         border-bottom-right-radius: 5px;\n         border-top-left-radius: 100%;\n         border-top-right-radius: 100%;\n         display: inline-block;\n         left: 56px;\n         position: absolute;\n         top: 10px;\n         font-size:x-large;\n         color:white;\n     }\n \n     #logo .reading_insurance_service\n     {\n         -webkit-animation: move_insurance_service 5s forwards;\n       transform: rotate(0deg);\n       transform-origin: bottom; \n       animation-fill-mode: forwards;\n     }\n     @-webkit-keyframes move_insurance_service {\n       0% {\n         transform: rotate(-90deg);\n         background: blue;\n       }\n       50% {\n         transform: rotate(90deg);\n         background: blue;\n       }\n       100% { \n         transform: rotate(-49deg);\n         transform: rotate(calc(((45deg*100)/75)*(180/100) - 90deg));\n         background: gold; \n       }\n     }\n \n     #logo .reading_logistics_service\n     {\n         -webkit-animation: move_logistics_service 5s forwards;\n       transform: rotate(0deg);\n       transform-origin: bottom; \n       animation-fill-mode: forwards;\n     }\n     @-webkit-keyframes move_logistics_service {\n       0% {\n         transform: rotate(-90deg);\n         background: blue;\n       }\n       50% {\n         transform: rotate(90deg);\n         background: blue;\n       }\n       100% { \n         transform: rotate(-90deg);\n         transform: rotate(calc(((0deg*100)/35)*(180/100) - 90deg));\n         background: red; \n       }\n     }\n \n     #logo .reading_products\n     {\n         -webkit-animation: move_products 5s forwards;\n       transform: rotate(0deg);\n       transform-origin: bottom; \n       animation-fill-mode: forwards;\n     }\n     @-webkit-keyframes move_products {\n       0% {\n         transform: rotate(-90deg);\n         background: blue;\n       }\n       50% {\n         transform: rotate(90deg);\n         background: blue;\n       }\n       100% { \n         transform: rotate(-45deg);\n         transform: rotate(calc(((3deg*100)/35)*(180/100) - 90deg));\n         background: gold; \n       }\n     }\n .debuglinks {\n    color: white;\n }\n .debuglinks:hover {\n    background-color: lighblue;\n }\n .ox-links a {\n     display: block;\n     position: relative;\n }\n .ox-links a:hover {\n color: lighblue;\n text-decoration: none;\n font-weight: bold;\n }\n .ox-links a::after {\n     transition: transform 400ms ease-in;\n     content: \"\";\n     width: 100%;\n     bottom: 0;\n     left: 0;\n     position: absolute;\n     height: 2px;\n     background-color: #10c55f;\n     transform: scale(0);\n }\n .ox-links a:hover::after {\n     transform: scale(0.5);\n     transform-origin: center;\n }\n \n \n :root {\n --status-color: Assigned;\n }\n .bg_funnel { \n    background-image:url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/191_image.png);\n    background-position-x:center; background-position-y:center; \n    background-size:100%; \n } \n .bg_funnel_1 { \n    background-image:url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/193_image.png); \n    background-position-x:center; \n    background-position-y:center; background-size:50%; \n } \n .bg_funnel_2 { \n    background-image:url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/194_image.png); \n    background-position-x:center; \n    background-position-y:center; \n    background-size:50%; \n } \n .bg_funnel_3 { \n    background-image:url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/195_image.png); \n    background-position-x:center; \n    background-position-y:center; \n    background-size:50%; \n } \n .bg_funnel_4 { \n    background-image:url(https://demo.oxzion.com/data/uploads/organization/1/userfiles/196_image.png); \n    background-position-x:center; \n    background-position-y:center; \n    background-size:50%; \n }\n \n #box-contain1 {\n padding: 30px;border:2px dashed teal;\n margin-bottom: 5px;\n }\n #box-contain2 {\n padding: 30px;\n border:5px double teal;\n }\n\n figure.oxzion-widget,\ndiv.oxzion-widget\n{\n\ttext-align: center;\n\toutline: solid 1px #ccc;\n\tbackground: rgba(0,0,0,0.05);\n\tpadding: 10px;\n\tmargin: 10px 20px;\n\tdisplay: inline-block;\n}\n\n/* figure > figcaption, */\nfigure.oxzion-widget > figcaption\n{\n\ttext-align: center;\n\tdisplay: block; /* For IE8 */\n}\n\n.ck-content .image {\n    display: table;\n    clear: both;\n    text-align: center;\n    margin: 1em auto;\n  }\n  .ck-content .image > img {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n    min-width: 50px;\n  }\n  \n  .ck-content .image > figcaption {\n    display: table-caption;\n    caption-side: bottom;\n    word-break: break-word;\n    color: #333;\n    background-color: #f7f7f7;\n    padding: 0.6em;\n    font-size: 0.75em;\n    outline-offset: -1px;\n  }\n  \n  .ck-content .image-style-align-center,\n  .ck-content .image-style-align-left,\n  .ck-content .image-style-align-right,\n  .ck-content .image-style-side {\n    max-width: 50%;\n  }\n  .ck-content .image-style-side {\n    float: right;\n    margin-left: var(--ck-image-style-spacing);\n  }\n  .ck-content .image-style-align-left {\n    float: left;\n    margin-right: var(--ck-image-style-spacing);\n  }\n  .ck-content .image-style-align-center {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .ck-content .image-style-align-right {\n    float: right;\n    margin-left: var(--ck-image-style-spacing);\n  }\n  .ck-content .image.image_resized {\n    max-width: 100%;\n    display: block;\n    box-sizing: border-box;\n  }\n  .ck-content .image.image_resized img {\n    width: 100%;\n  }\n  .ck-content .image.image_resized > figcaption {\n    display: block;\n  }\n  .ck-content .media {\n    clear: both;\n    margin: 1em 0;\n    display: block;\n    min-width: 15em;\n  }\n  .ck-content .table {\n    margin: 1em auto;\n    display: table;\n  }\n  .ck-content .table table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    height: 100%;\n    border: 1px double #b3b3b3;\n  }\n  .ck-content .table table td,\n  .ck-content .table table th {\n    min-width: 2em;\n    padding: 0.4em;\n    border: 1px solid #bfbfbf;\n  }\n  .ck-content .table table th {\n    font-weight: 700;\n    background: hsla(0, 0%, 0%, 5%);\n  }\n  .ck-content[dir=\"rtl\"] .table th {\n    text-align: right;\n  }\n  .ck-content[dir=\"ltr\"] .table th {\n    text-align: left;\n  }\n  .ck-content .text-tiny {\n    font-size: 0.7em;\n  }\n  .ck-content .text-small {\n    font-size: 0.85em;\n  }\n  .ck-content .text-big {\n    font-size: 1.4em;\n  }\n  .ck-content .text-huge {\n    font-size: 1.8em;\n  }\n  .ck-content blockquote {\n    overflow: hidden;\n    padding-right: 1.5em;\n    padding-left: 1.5em;\n    margin-left: 0;\n    margin-right: 0;\n    font-style: italic;\n    border-left: 5px solid #ccc;\n  }\n  .ck-content[dir=\"rtl\"] blockquote {\n    border-left: 0;\n    border-right: 5px solid #ccc;\n  }\n\n  .activityLogWindow .logResults .gridActions .ck-content {\n    width: 100%;\n    word-wrap: break-word;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
